// latest: zhangmyh 2017-2-21 3:04 PM
import { Model } from 'common'

Model.define('evalapply.evaobj', {
  meta: {
    supplyDocCode: '',
    supEnterpriseId: '',
    supplyDocId: '',
    supplyDocName: ''
  }
})



// WEBPACK FOOTER //
// ./src/data/model/evaluationApply/evaObj.js